module.exports = __webpack_public_path__ + "img/helene_n.04a8c72d.png";